import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let ThemeEmbeddedContainerElement = class ThemeEmbeddedContainerElement extends LitElement {
    static { this.tagName = 'inch-theme-embedded-container'; }
    render() {
        return html `<slot></slot>`;
    }
};
ThemeEmbeddedContainerElement = __decorate([
    customElement(ThemeEmbeddedContainerElement.tagName)
], ThemeEmbeddedContainerElement);
export { ThemeEmbeddedContainerElement };
//# sourceMappingURL=theme-embedded-container.element.js.map